import PropTypes from 'prop-types';
import React from 'react';
import Snackbar from 'containers/Snackbar';
import AutoTimeout from 'containers/AutoTimeout';

class LayoutContainer extends React.Component {
  constructor(props){
    super(props);
  }

  render() {
    return (
      <AutoTimeout
        children={
          <React.Fragment>
            {this.props.children}
            <Snackbar />
          </React.Fragment>
        }
      />
    );
  }
}

LayoutContainer.propTypes = {
  children: PropTypes.element,
};

export default LayoutContainer;
